import localStorageHelper from '@/helpers/localStorageHelper'
import trackingHelper from '@/helpers/trackingHelper'

const state = () => ({
  investItems: []
})

// getters
const getters = {
  investCount: (state) =>
  {
    if (!state.investItems.length)
    {
      const investsLocalStorage = localStorageHelper.getJson('invests')
      if (investsLocalStorage)
      {
        investsLocalStorage.forEach(function (item)
          {
            state.investItems.push(item)
          }
        )
      }
    }
    return state.investItems.length
  },
  getInvestItems: (state) =>
  {
    return state.investItems
  },
  getTotalInvestAmount: (state) =>
  {
    try
    {
      return state.investItems.reduce(function (s, a)
      {
        return s + parseFloat(a.amount)
      }, 0)
    }
    catch (e)
    {
      console.log('Failed counting of TotalInvestAmount', e)
    }
  }
}

// actions
const actions = {
  addInvestItem({state, commit}, item)
  {
    commit('pushInvestItem', item)
  },
  updateInvestItem({state, commit}, item)
  {
    commit('updateInvestItem', item)
  },
  removeInvestItem({state, commit}, itemId)
  {
    commit('removeInvestItem', itemId)
  },
  removeAll({state, commit})
  {
    commit('removeAll')
  }
}

// mutations
const mutations = {
  pushInvestItem(state, item)
  {
    // check if already added
    let investsLocalStorage = localStorageHelper.getJson('invests')
    if (investsLocalStorage)
    {
      const invest = investsLocalStorage.filter(i => i.loan_ref === item.loan_ref)
      if (invest.length && invest[0])
      {
        // Already added in confirmation. Just (sum) update amount.
        // console.log('Current invest invest[0].amount: ', currentInvestAmount)
        // console.log('Need to add item.amount: ', item.amount)
        // console.log('SUM: ', parseFloat(item.amount) + currentInvestAmount)
        const currentInvestAmount = parseFloat(invest[0].amount)
        const amount = parseFloat(item.amount) + currentInvestAmount

        if (item.investable_amount && parseFloat(item.investable_amount) < amount)
        {
          console.log('Not enough: ', item.investable_amount)
          // TODO show universal error(toast) Not enough
        }

        // Update amount in VUEX item
        state.investItems.forEach(function (investItem, index)
        {
          if (investItem.loan_ref === invest[0].loan_ref)
          {
            state.investItems[index].amount = amount
          }
        })

        // Update amount in LS
        investsLocalStorage.forEach(function (investItem, index)
        {
          if (investItem.loan_ref === item.loan_ref)
          {
            investsLocalStorage[index].amount = amount
          }
        })
        investsLocalStorage = investsLocalStorage.filter((item) =>
        {
          return item
        })
        localStorageHelper.setAsJson('invests', investsLocalStorage)
      }
      else
      {
        // It's first invest with this loan_ref. Just add to VUEX and LS
        state.investItems.push(item)
        trackingHelper.pushToDataLayer('addToCart', [item])
        investsLocalStorage.push(item)
        localStorageHelper.setAsJson('invests', investsLocalStorage)
      }
    }
    else
    {
      // Events LS is empty. Create new
      localStorageHelper.setAsJson('invests', [item])
      state.investItems.push(item)
      trackingHelper.pushToDataLayer('addToCart', [item])
    }
  },
  removeInvestItem(state, itemId)
  {
    state.investItems = state.investItems.filter((item) =>
    {
      if (item.loan_ref === itemId) {
        trackingHelper.pushToDataLayer('removeFromCart', [item])
      }
      return item.loan_ref !== itemId
    })

    let investsLocalStorage = localStorageHelper.getJson('invests')
    if (investsLocalStorage)
    {
      investsLocalStorage = investsLocalStorage.filter((item) =>
      {
        return item.loan_ref !== itemId
      })
      localStorageHelper.setAsJson('invests', investsLocalStorage)
    }
  },
  removeAll(state)
  {
    state.investItems = []
    localStorageHelper.set('invests', [])
  },
  updateInvestItem(state, item)
  {
    state.investItems.forEach(function (investItem, index)
    {
      if (investItem.loan_ref === item.loan_ref)
      {
        state.investItems[index].amount = item.amount
      }
    })

    let investsLocalStorage = localStorageHelper.getJson('invests')
    if (investsLocalStorage)
    {
      investsLocalStorage.forEach(function (investItem, index)
      {
        if (investItem.loan_ref === item.loan_ref)
        {
          investsLocalStorage[index].amount = item.amount
        }
      })
      investsLocalStorage = investsLocalStorage.filter((item) =>
      {
        return item
      })
      localStorageHelper.setAsJson('invests', investsLocalStorage)
    }

    state.investItems = state.investItems.filter((item) =>
    {
      return item
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
